import { render, staticRenderFns } from "./activityGoodsList.vue?vue&type=template&id=6035366b&scoped=true"
import script from "./activityGoodsList.vue?vue&type=script&lang=js"
export * from "./activityGoodsList.vue?vue&type=script&lang=js"
import style0 from "./activityGoodsList.vue?vue&type=style&index=0&id=6035366b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035366b",
  null
  
)

export default component.exports